import { CustomOrderEntry } from '@cart/const';

export function findEntryByGuid(entries: CustomOrderEntry[], guid: string): CustomOrderEntry | undefined {
  return entries.find((entry) => entry.positionGuid === guid);
}
